import { render, staticRenderFns } from "./YFZDdetils.vue?vue&type=template&id=681fd1d9&scoped=true&"
import script from "./YFZDdetils.vue?vue&type=script&lang=js&"
export * from "./YFZDdetils.vue?vue&type=script&lang=js&"
import style0 from "./YFZDdetils.vue?vue&type=style&index=0&id=681fd1d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681fd1d9",
  null
  
)

export default component.exports